import { ADD_INVOICE_DETAIL_INVOICE_REGISTER, UPDATE_INVOICE_DETAIL_INVOICE_REGISTER, SET_ITBIS_TAX_INVOICE_REGISTER, DELETE_INVOICE_DETAIL_INVOICE_REGISTER, RESER_INVOICE_REGISTER,SET_FILE,RESET_FILE, MODIFY_FILE } from '../../../../constants/ActionTypes'
import { ID } from '../../../../constants/Config'
const InitialState = {
    TableData: [],
    percentItbis: null,
    IdCurrentRow: ID(),
    file:[]
}

function InvoiceRegister(state = InitialState, action) {
    switch (action.type) {
        case ADD_INVOICE_DETAIL_INVOICE_REGISTER:
            const NewRow = action.payload;
            console.log("Agregar", NewRow)
            return {
                ...state,
                TableData: [...state.TableData, NewRow],
                IdCurrentRow: ID()
            }
        case UPDATE_INVOICE_DETAIL_INVOICE_REGISTER:
            const UpdateRow = action.payload;
            return {
                ...state,
                TableData: state.TableData.map(x => x.id === UpdateRow.id ? UpdateRow : x)
            }
        case DELETE_INVOICE_DETAIL_INVOICE_REGISTER:
            const { productId } = action.payload;
            return {
                ...state,
                TableData: state.TableData.filter(x => x.productId !== productId)
            }
        case SET_ITBIS_TAX_INVOICE_REGISTER:
            return {
                ...state,
                percentItbis: action.payload.percentItbis * 0.01
            }

        case SET_FILE:
            return {
                ...state,
                file: [...state.file, action.payload]
            }

        case MODIFY_FILE:
            const UpdateFile = action.payload;
            return {
                ...state,
                file:state.file.filter(item => item.uid !== UpdateFile.uid)
            }

        case RESET_FILE:
                return {
                    ...state,
                    file: []
                }
                
        case RESER_INVOICE_REGISTER:
            return {
                ...state,
                TableData: [],
                IdCurrentRow: ID()
            }
        default:
            return state;
    }

}

export default InvoiceRegister;